export const ACCESSIBILITY_OPTIONS = {
  text: {
    fontSize: { levels: 3, classes: ['a11y-font-size-1', 'a11y-font-size-2', 'a11y-font-size-3'], label: 'Rozmiar tekstu' },
    lineHeight: { levels: 3, classes: ['a11y-line-height-1', 'a11y-line-height-2', 'a11y-line-height-3'], label: 'Interlinia' },
    letterSpacing: { levels: 3, classes: ['a11y-letter-spacing-1', 'a11y-letter-spacing-2', 'a11y-letter-spacing-3'], label: 'Odstępy między znakami' },
    dyslexicFont: { toggle: true, class: 'a11y-dyslexic-font', label: 'Czcionka dla dyslektyków' },
    highlightLinks: { toggle: true, class: 'a11y-highlight-links', label: 'Podkreślenie linków' },
    bionicReading: { toggle: true, class: 'a11y-bionic', label: 'Czytanie bioniczne' },
    magnifier: { toggle: true, class: 'a11y-magnifier', label: 'Lupa' },
    readingPacer: { levels: 3, classes: ['a11y-reading-pacer-1', 'a11y-reading-pacer-2', 'a11y-reading-pacer-3'], label: 'Wskaźnik czytania' },
    contentChunking: { toggle: true, class: 'a11y-content-chunking', label: 'Dzielenie treści' },
    textToSpeech: { toggle: true, class: 'a11y-text-to-speech', label: 'Czytaj na głos (AI)' },
    ttsSpeed: { default: 1, range: [0.75, 1, 1.25], label: 'Prędkość mowy' },
    ttsMode: { default: 'click', values: ['click', 'hover'], label: 'Tryb odczytu' },
    aiVision: { toggle: true, class: 'a11y-ai-vision', label: 'Opis obrazków (AI)' },
    textSimplifier: { toggle: true, class: 'a11y-text-simplifier', label: 'Wyjaśnij tekst (AI)' },
  },
  color: {
    invert: { toggle: true, class: 'a11y-invert', label: 'Odwróć kolory' },
    contrast: { toggle: true, class: 'a11y-high-contrast', label: 'Kontrast' },
    saturation: { levels: 3, classes: ['a11y-saturation-1', 'a11y-saturation-2', 'a11y-saturation-3'], label: 'Nasycenie' },
    colorBlindness: { levels: 3, classes: ['a11y-cb-1', 'a11y-cb-2', 'a11y-cb-3'], label: 'Korekcja daltonizmu' },
  },
  tools: {
    disableAnimations: { toggle: true, class: 'a11y-disable-animations', label: 'Wyłącz animacje' },
    largeCursor: { toggle: true, class: 'a11y-large-cursor', label: 'Powiększ kursor' },
    hideImages: { toggle: true, class: 'a11y-hide-images', label: 'Ukryj zdjęcia i wideo' },
    readingRuler: { toggle: true, class: 'a11y-reading-ruler', label: 'Pokaż linijkę' },

    virtualReadingWindow: { toggle: true, class: 'a11y-virtual-window', label: 'Wirtualne okno czytania' },
    semanticOverlay: { toggle: true, class: 'a11y-semantic-overlay-active', label: 'Nakładka semantyczna' },
    focusPath: { toggle: true, class: 'a11y-focus-path', label: 'Ścieżka fokusu' },
    delayedHover: { levels: 3, classes: ['a11y-delayed-hover-1', 'a11y-delayed-hover-2', 'a11y-delayed-hover-3'], label: 'Opóźnienie hover' },
    autoScroll: { levels: 3, classes: ['a11y-auto-scroll-1', 'a11y-auto-scroll-2', 'a11y-auto-scroll-3'], label: 'Auto-przewijanie' },
    smartNavigation: { toggle: true, class: 'a11y-smart-navigation', label: 'Inteligentna nawigacja (AI)' },
    soundFeedback: { toggle: true, class: 'a11y-sound-feedback', label: 'Dźwięki interakcji' },
  },
};
